var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneOutgoingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66965 11.7015C9.44762 13.292 10.7369 14.5754 12.3309 15.3461C12.4475 15.4014 12.5765 15.4253 12.7052 15.4156C12.8339 15.4059 12.9579 15.3628 13.0648 15.2906L15.4119 13.7255C15.5157 13.6563 15.6352 13.6141 15.7594 13.6027C15.8837 13.5912 16.0088 13.611 16.1235 13.6602L20.5144 15.542C20.6636 15.6054 20.7881 15.7155 20.8693 15.8558C20.9504 15.9961 20.9838 16.1589 20.9643 16.3198C20.8255 17.4058 20.2956 18.404 19.4739 19.1275C18.6521 19.8509 17.5948 20.25 16.5 20.2501C13.1185 20.2501 9.87548 18.9068 7.48439 16.5157C5.0933 14.1246 3.75 10.8816 3.75 7.50009C3.75006 6.40526 4.14918 5.34798 4.87264 4.52623C5.5961 3.70447 6.59428 3.1746 7.68028 3.03581C7.84117 3.01634 8.00403 3.04968 8.14432 3.13082C8.28461 3.21195 8.39473 3.33648 8.4581 3.48564L10.3416 7.88044C10.3903 7.99412 10.4101 8.11808 10.3994 8.24128C10.3886 8.36449 10.3475 8.48311 10.2798 8.58659L8.72011 10.9697C8.64912 11.0769 8.60716 11.2007 8.59831 11.329C8.58947 11.4572 8.61405 11.5856 8.66965 11.7015V11.7015Z",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4.5H19.5V8.25",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L19.5 4.5",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutgoingIcon);
export default __webpack_public_path__ + "static/media/phone-outgoing-icon.374866540ce4397ecab9b35b0bbb31c7.svg";
export { ForwardRef as ReactComponent };